<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.70414 5.70414L19.0711 19.0711C19.4616 19.4616 19.4616 20.0948 19.0711 20.4853C18.6805 20.8758 18.0474 20.8758 17.6569 20.4853L16.0638 18.8924C15.145 19.4354 14.1081 19.7998 13.001 19.938L13 21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21L11 19.9381C7.05371 19.446 4 16.0796 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12C6 15.3137 8.68629 18 12 18C12.9259 18 13.8029 17.7903 14.5859 17.4157L13.0349 15.8648C12.7048 15.953 12.3579 16 12 16C9.79086 16 8 14.2091 8 12L7.99993 10.829L4.29183 7.12025C3.9013 6.72973 3.9013 6.09656 4.29183 5.70604C4.68172 5.31615 5.31346 5.31552 5.70414 5.70414ZM19 11C19.5523 11 20 11.4477 20 12C20 13.4835 19.5962 14.8727 18.8925 16.0637L17.4155 14.5863C17.7902 13.8032 18 12.9261 18 12C18 11.4477 18.4477 11 19 11ZM12 2C14.2091 2 16 3.79086 16 6V12C16 12.3579 15.953 12.7049 15.8648 13.035L13.9999 11.171L14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6L9.99993 7.171L8.07145 5.24342C8.42511 3.39604 10.0495 2 12 2Z"
    fill="currentColor"
  />
</svg>
